import { Text } from '@hhgtech/hhg-components/mantine'
import { Warning } from '@hhgtech/icons/core'
import { BoxProps, Flex } from '@mantine/core'
import { shallow } from 'zustand/shallow'

import { useAirPopulationStore } from 'state/airPopulation'

import useStyles from './index.styles'

export const Disclaimer = ({ className, ...rest }: BoxProps) => {
  const { classes, theme, cx } = useStyles(undefined, {
    name: 'AirPopulation__Disclaimer',
  })
  const { disclaimer } = useAirPopulationStore(
    (state) => ({
      disclaimer: state.cardInfo?.disclaimer,
    }),
    shallow,
  )
  if (!disclaimer) return null
  return (
    <Flex gap={4} {...rest} className={cx(className, classes.root)}>
      <Warning
        size={16}
        color={theme.colors.yellow[8]}
        className={classes.icon}
      />
      <Text size="c1">{disclaimer}</Text>
    </Flex>
  )
}
